import m from "../../geodata/es2015/hondurasHigh";
window.am4geodata_hondurasHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/hondurasHigh.js
// module id = null
// module chunks = 